import CustomInput from "../../components/CustomInput";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import CustomButton from "../../components/CustomButton";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "@fontsource/inter";
import loginImage from '../../assets/images/tennis-court.jpg';
import '../../assets/css/ForgetPassword.css';
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowBack } from "react-icons/io";

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: '',
    });

    const [errors, setErrors] = useState({
        emailOrPhone: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear error when user types
        }));
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

  const isValidPhone = (phone) => {
    const phoneRegex = /^(?:\+1\s?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return phoneRegex.test(phone);
};

    const handleSubmit = async () => {
        const identifier = formData.emailOrPhone.trim();

        if (!isValidEmail(identifier) && !isValidPhone(identifier)) {
            setErrors({ emailOrPhone: 'Please enter a valid email or 10-digit phone number' });
            return;
        }

        try {
            const url = `${endpoint.FORGET_PASSWORD}?identifier=${identifier}`;
            const result = await apiHandler({
                url,
                method: "GET",
            });

            if (result.data.message === "Password reset instructions sent successfully.") {
                toast.success(result.data.message);
                navigate('/sendotp', { state: { email: identifier } });
            } else {
                toast.error(result.data.error_description || "User with this email or mobile number does not exist");
            }
        } catch (error) {
            toast.error(error.message || "An unexpected error occurred.");
        }
    };

    const onRegisterNow = () => {
        navigate('/register');
    };

    const onBackTo = () => {
        navigate(-1);
    };
    const onLogin = ()=>{
        navigate('/login')
    }

    return (
        <>
            <div>
                <img src={loginImage} className="forget-password-img" alt="Forgot Password" />
            </div>
            <div className="forget-password-conatiner">
                <div className="d-flex align-items-center justify-content-center h-100">
                    <div className='cont-log-in-container forget-password-wrapper p-3'>
                        <div className='col-lg-12 co-sm-12 forget-password-content p-4'>
                            <h3 className='text-start fw-bolder fs-4 sign-up-text '>Forget Password</h3>
                            <div className="mt-3">
                                <CustomInput
                                    label="Email Or Phone"
                                    name="emailOrPhone"
                                    placeholder="Email Or Phone"
                                    type="text"
                                    value={formData.emailOrPhone}
                                    onChange={handleInputChange}
                                />
                                {errors.emailOrPhone && (
                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                        {errors.emailOrPhone}
                                    </div>
                                )}
                                <div className="pt-5">
                                    <CustomButton
                                        buttonText="Send OTP"
                                        style={{
                                            width: '100%',
                                            height: '48px',
                                            borderRadius: '12px',
                                            background: '#006FFD',
                                            color: '#FFFFFF',
                                            border: 'none',
                                        }}
                                        onClick={handleSubmit}
                                    />
                                </div>
                                <div className='logIn-register-text'>
                                <span className="login-reg-now-txt" onClick={onLogin} style={{cursor:'pointer'}}> <IoIosArrowBack style={{ fontSize: '21px' }}/> Back to login</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgetPassword;
